import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ILoyaltyPointState } from '../redux/LoyaltyPoints.reducer';
import { getLoyaltyPoints } from '../redux/LoyaltyPoints.actions';
import USER_CONFIG from 'config/User.config';

const useLoyaltyPointsEffects = (): any => {
  const dispatch = useDispatch();
  const loyalty = useSelector((state: { loyalty: ILoyaltyPointState }) => state.loyalty);
  useEffect(() => {
    if (USER_CONFIG.isLoggedIn && loyalty.totalPoints === '') {
      dispatch(getLoyaltyPoints());
    }
  }, [dispatch, loyalty.totalPoints]);
  return { ...loyalty };
};

export default useLoyaltyPointsEffects;
